var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('qrcode-stream',{on:{"decode":_vm.onDecode,"init":_vm.onInit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }